module.exports = __webpack_public_path__ + "static/img/card-curso.9081bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-curso.jpg
// module id = UTC9
// module chunks = 47